"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DetailItem = require("./DetailItem");
Object.keys(_DetailItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItem[key];
    }
  });
});
var _DetailItemCaption = require("./DetailItemCaption");
Object.keys(_DetailItemCaption).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemCaption[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemCaption[key];
    }
  });
});
var _DetailItemImage = require("./DetailItemImage");
Object.keys(_DetailItemImage).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemImage[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemImage[key];
    }
  });
});
var _DetailItemReport = require("./DetailItemReport");
Object.keys(_DetailItemReport).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemReport[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemReport[key];
    }
  });
});
var _DetailItemShare = require("./DetailItemShare");
Object.keys(_DetailItemShare).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemShare[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemShare[key];
    }
  });
});
var _DetailItemShop = require("./DetailItemShop");
Object.keys(_DetailItemShop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemShop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemShop[key];
    }
  });
});
var _DetailItemVideo = require("./DetailItemVideo");
Object.keys(_DetailItemVideo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DetailItemVideo[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DetailItemVideo[key];
    }
  });
});
var _EmphasizeText = require("./EmphasizeText");
Object.keys(_EmphasizeText).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EmphasizeText[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _EmphasizeText[key];
    }
  });
});
var _LoadMore = require("./LoadMore");
Object.keys(_LoadMore).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoadMore[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoadMore[key];
    }
  });
});
var _MediaItem = require("./MediaItem");
Object.keys(_MediaItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MediaItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MediaItem[key];
    }
  });
});
var _OlapicGallery = require("./OlapicGallery");
Object.keys(_OlapicGallery).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicGallery[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicGallery[key];
    }
  });
});
var _OlapicSlider = require("./OlapicSlider");
Object.keys(_OlapicSlider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicSlider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicSlider[key];
    }
  });
});
var _OlapicSliderButtons = require("./OlapicSliderButtons");
Object.keys(_OlapicSliderButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OlapicSliderButtons[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OlapicSliderButtons[key];
    }
  });
});
var _WidgetSkeleton = require("./WidgetSkeleton");
Object.keys(_WidgetSkeleton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetSkeleton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetSkeleton[key];
    }
  });
});
